import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';

// Internacionalização (i18n)
import './i18n';

import './styles/reset.css';
import './styles/scrollbar-global.css';
import './styles/page-titles.css';

import { applyBrandMeta } from './utils/brandMeta';
// Silenciar console.log/debug/info em produção (fallback caso babel plugin não atue)
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

// Set page title and favicon based on region before React renders
applyBrandMeta();

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

// O loading HTML será removido pelo AuthProvider quando terminar de carregar
// via window.__removeInitialLoading() chamado no contexto de auth
